export default __webpack_public_path__ + "static/media/FacilityMaster.a777c05c.svg";